export const STATUS = {
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    RUNNING: 'RUNNING',
};

export default STATUS;
